import type { Build } from '@/api/schemas';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Input } from '@/components/ui/input';

interface Props {
  build: Build;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reason: string;
  onReasonChange: (reason: string) => void;
  onConfirm: () => void;
}

/** Confirms cancelling a build, with an optional reason. */
export function CancelBuildDialog({ build: b, open, onOpenChange, reason, onReasonChange, onConfirm }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="build-cancel-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel {b.ref}?</AlertDialogTitle>
          <AlertDialogDescription>Hangar asks the build service to stop the build; it shows as canceled once the service confirms. The build number can be used again.</AlertDialogDescription>
        </AlertDialogHeader>
        <Input data-testid="build-cancel-reason" value={reason} onChange={(e) => onReasonChange(e.target.value)} placeholder="Reason (optional) · e.g. superseded by #1290" maxLength={500} />
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="build-cancel-dismiss">Keep running</AlertDialogCancel>
          <AlertDialogAction
            destructive
            data-testid="build-cancel-confirm"
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
          >
            Cancel build
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
